import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function StopSharing({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;background:var(--bg-overlay);display:flex;flex-direction:column;justify-content:flex-end")}>
      <div style={sx("padding:28px 20px 34px;border-radius:28px 28px 54px 54px;background:var(--bg-secondary);box-shadow:var(--shadow-bottom-sheet);display:flex;flex-direction:column;gap:16px;animation:gpop 250ms var(--ease-out)")}>
        <span style={sx("width:56px;height:56px;border-radius:var(--radius-md);background:var(--bg-warning-subtle);display:flex;align-items:center;justify-content:center")}>
          <span style={sx("width:26px;height:26px;background:var(--text-warning);-webkit-mask:url(/assets/icons/alert-triangle.svg) center/contain no-repeat;mask:url(/assets/icons/alert-triangle.svg) center/contain no-repeat")} />
        </span>
        <span style={sx("font-size:var(--fs-4xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:32px")}>
          Stop sharing blocked threats?
        </span>
        <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary)")}>
          Michael will no longer be told when this iPhone blocks a scam call or a dangerous site. Your protection stays on either way.
        </span>
        <div style={sx("display:flex;gap:10px;align-items:center;padding:12px 14px;border-radius:var(--radius-md);background:var(--bg-tertiary)")}>
          <span style={sx("width:18px;height:18px;flex:none;background:var(--text-secondary);-webkit-mask:url(/assets/icons/info.svg) center/contain no-repeat;mask:url(/assets/icons/info.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-xs);line-height:18px")}>
            Alerts already sent stay in his feed. You can turn sharing back on anytime.
          </span>
        </div>
        <div style={sx("display:flex;flex-direction:column;gap:8px;margin-top:4px")}>
          <button onClick={v.confirmStopSharing} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-critical);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
            Stop sharing
          </button>
          <button onClick={v.keepSharing} style={sx("height:44px;border-radius:var(--radius-full);border:none;background:transparent;color:var(--text-secondary);font-family:inherit;font-size:var(--fs-sm);cursor:pointer")}>
            Keep sharing
          </button>
        </div>
      </div>
    </div>
  )
}
